import { render, staticRenderFns } from "./RegionsCatalog.vue?vue&type=template&id=2310da18&"
import script from "./RegionsCatalog.vue?vue&type=script&lang=js&"
export * from "./RegionsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports